"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var NarrowSConnector_1 = __importDefault(require("./NarrowSConnector"));
var LineConnector_1 = __importDefault(require("./LineConnector"));
var SConnector_1 = __importDefault(require("./SConnector"));
/**
 * Connect elements with svg paths
 * @param el1 first element (HTML or React component)
 * @param el2 second element (HTML or React component)
 * @param shape s | line | narrow-s
 * @param direction (right, left, top, bottom) --> (right, left, top, bottom) if shape is narrow-s
 * @param grid number of columns in X/Y axis from the start point to the end point
 * @param stem min distance from the start point to the first transition
 * @param minStep radius of the transition curve, default is min of (deltaX/grid, deltaY/grid)
 * @param roundCorner true to have a curve transition
 * @param stroke color of the svg path
 * @param strokeWidth width of the svg path
 * @param startArrow true to have an arrow at the start point (not applicable for s shape)
 * @param endArrow true to have an arrow at the end point (not applicable for s shape)
 * @param arrowSize size of arrows
 */
function SvgConnector(props) {
    var _a, _b, _c, _d;
    var wrapperRef = react_1.useRef(null);
    function getCoords(el) {
        var parentEl = el.offsetParent;
        var box = el.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset + ((parentEl === null || parentEl === void 0 ? void 0 : parentEl.scrollTop) || 0),
            right: box.right + window.pageXOffset + ((parentEl === null || parentEl === void 0 ? void 0 : parentEl.scrollLeft) || 0),
            bottom: box.bottom + window.pageYOffset + ((parentEl === null || parentEl === void 0 ? void 0 : parentEl.scrollTop) || 0),
            left: box.left + window.pageXOffset + ((parentEl === null || parentEl === void 0 ? void 0 : parentEl.scrollLeft) || 0),
        };
    }
    function getNewCoordinates() {
        var el1Coords = getCoords(props.el1);
        var el2Coords = getCoords(props.el2);
        var el1Dimesion = {
            width: el1Coords.right - el1Coords.left,
            height: el1Coords.bottom - el1Coords.top,
        };
        var el2Dimesion = {
            width: el2Coords.right - el2Coords.left,
            height: el2Coords.bottom - el2Coords.top,
        };
        var start = {
            x: el1Coords.right,
            y: el1Coords.top + el1Dimesion.height / 2,
        };
        var end = {
            x: el2Coords.left,
            y: el2Coords.top + el2Dimesion.height / 2,
        };
        switch (props.direction) {
            case "l2l":
                start.x = el1Coords.left;
                break;
            case "l2r":
                start.x = el1Coords.left;
                end.x = el2Coords.right;
                break;
            case "r2r":
                start.x = el1Coords.right;
                end.x = el2Coords.right;
                break;
            case "b2t":
                start = {
                    x: el1Coords.left + el1Dimesion.width / 2,
                    y: el1Coords.bottom,
                };
                end = {
                    x: el2Coords.left + el2Dimesion.width / 2,
                    y: el2Coords.top,
                };
                break;
            case "b2b":
                start = {
                    x: el1Coords.left + el1Dimesion.width / 2,
                    y: el1Coords.bottom,
                };
                end = {
                    x: el2Coords.left + el2Dimesion.width / 2,
                    y: el2Coords.bottom,
                };
                break;
            case "t2t":
                start = {
                    x: el1Coords.left + el1Dimesion.width / 2,
                    y: el1Coords.top,
                };
                end = {
                    x: el2Coords.left + el2Dimesion.width / 2,
                    y: el2Coords.top,
                };
                break;
            case "t2b":
                start = {
                    x: el1Coords.left + el1Dimesion.width / 2,
                    y: el1Coords.top,
                };
                end = {
                    x: el2Coords.left + el2Dimesion.width / 2,
                    y: el2Coords.bottom,
                };
                break;
            default:
                break;
        }
        return { start: start, end: end };
    }
    if (!props.el1 || !props.el2)
        return null;
    var coordinates = getNewCoordinates();
    return (react_1.default.createElement("div", { ref: wrapperRef, style: {
            position: "absolute",
            top: 0,
            width: ((_b = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetParent) === null || _b === void 0 ? void 0 : _b.scrollWidth) || "100%",
            height: ((_d = (_c = wrapperRef.current) === null || _c === void 0 ? void 0 : _c.offsetParent) === null || _d === void 0 ? void 0 : _d.scrollHeight) || "100%",
            zIndex: -1,
        } },
        props.shape === "line" && (react_1.default.createElement(LineConnector_1.default, __assign({}, props, { startPoint: coordinates.start, endPoint: coordinates.end, startArrow: props.startArrow, endArrow: props.endArrow, arrowSize: props.arrowSize }))),
        props.shape === "s" && (react_1.default.createElement(SConnector_1.default, __assign({}, props, { startPoint: coordinates.start, endPoint: coordinates.end, startArrow: props.startArrow, endArrow: props.endArrow, arrowSize: props.arrowSize }))),
        props.shape === "narrow-s" && (react_1.default.createElement(NarrowSConnector_1.default, __assign({}, props, { startPoint: coordinates.start, endPoint: coordinates.end, stem: props.stem, grids: props.grids, roundCorner: props.roundCorner, direction: props.direction, minStep: props.minStep, startArrow: props.startArrow, endArrow: props.endArrow, arrowSize: props.arrowSize })))));
}
exports.default = SvgConnector;
